/* istanbul ignore file */
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { getSafeRedirectUrl } from '@kiwicom/account-client-utils';

import { getToken, getLanguage, normalizeQueryParam } from '../util';

const parseRedirectUrl = (query: string) => {
  const asArray = query.split('/');

  if (asArray[0] !== '') {
    // Not internal url
    return query;
  }

  return ['/[language]', ...asArray.slice(2)].join('/');
};

export default function useRedirectOnLoggedIn() {
  const { push, query } = useRouter();
  const token = getToken();
  useEffect(() => {
    if (token != null) {
      const redirectUrl = getSafeRedirectUrl(query.redirectUrl as string);
      const language = getLanguage();

      if (redirectUrl != null) {
        push(parseRedirectUrl(normalizeQueryParam(query.redirectUrl)), redirectUrl);
      } else {
        push('/[language]/user', `/${language}/user`);
      }
    }
  }, [push, query.redirectUrl, token]);
}
